import { Mark } from "./Botanical";

export const Footer = () => (
    <footer className="bg-[#2A0813] py-10" data-testid="footer">
        <div className="mx-auto flex max-w-5xl flex-col items-center gap-4 px-5 text-center sm:px-8">
            <div className="flex items-center gap-2.5">
                <Mark className="h-7 w-7 rounded-md" />
                <span className="font-sans text-[0.62rem] font-bold uppercase tracking-[0.28em] text-cream/90">
                    The 5-Day Husband Reset Guide
                </span>
            </div>
            <p className="max-w-md font-sans text-xs leading-relaxed text-cream/50" data-testid="footer-disclaimer">
                This guide is a self-reflection resource and is not a substitute for professional therapy or
                counselling. Payments are processed securely via Razorpay.
            </p>
            <a
                href={`https://wa.me/${process.env.REACT_APP_WHATSAPP_NUMBER}`}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 rounded-full border border-gold/40 px-4 py-2 font-sans text-[0.65rem] font-semibold uppercase tracking-[0.18em] text-gold transition-colors duration-300 hover:bg-gold/10"
                data-testid="footer-whatsapp-link"
            >
                Further consultation &bull; WhatsApp 85109 13703
            </a>
            <p className="font-sans text-[0.65rem] uppercase tracking-[0.2em] text-cream/40">
                &copy; {new Date().getFullYear()} Dipa M Kapur &bull; All rights reserved
            </p>
        </div>
    </footer>
);

export default Footer;
